import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { userContestCollaborationWhitelistBackend } from './user-contest-collaboration-whitelist.backend';
import { userContestCollaborationWhitelistReducer } from './user-contest-collaboration-whitelist.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'userContestCollaborationWhitelist',
      userContestCollaborationWhitelistReducer,
    ),
    BackendModule.forFeature(
      'userContestCollaborationWhitelist',
      userContestCollaborationWhitelistBackend,
    ),
  ],
})
export class DatastoreUserContestCollaborationWhitelistModule {}
